import { Link, useHistory } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Hidden from '@material-ui/core/Hidden';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import { useAuth } from '../../contexts/auth';
import { PepsicoWhite } from '../../assets/images';
import { BellIcon } from '../../assets/icons/dashboard';
import useStyles from './styles';
import { ArrowLeftIcon } from '../../assets/icons';
import NotificationsButton from './NotificationButton';

interface Props {
  innerPage?: boolean;
  hideBackButton?: boolean;
  backLink?: string;
}

const Header = ({
  innerPage = false,
  hideBackButton = false,
  backLink,
}: Props) => {
  const { user, isGPID } = useAuth();
  const { push } = useHistory();
  const theme = useTheme();
  const isUpSm = useMediaQuery(theme.breakpoints.up('sm'));
  const classes = useStyles();

  return (
    <Grid container component="header" className={classes.container}>
      {!innerPage || isUpSm ? (
        <Grid container item xs={12} md={9}>
          <Grid container item xs={6} className={classes.imageContainer}>
            <Link to={!isGPID ? '/' : '/minha-saude/vacina'}>
              <img  src={PepsicoWhite} alt="Logo" draggable="false" />
            </Link>
          </Grid>
          <Grid item xs={6}>
            <Grid container spacing={1} className={classes.menu}>
              <Grid item>
                <Hidden smDown>
                  <Typography variant="body1" className={classes.title}>
                    Olá! {user.firstName}!
                  </Typography>
                </Hidden>
              </Grid>
              <Grid item>
                <IconButton size="small" onClick={() => push('/perfil')}>
                  <Avatar
                    alt={user.firstName}
                    src={user.image}
                    className={classes.userAvatar}
                  >
                    {user.firstName.substr(0, 1)}
                  </Avatar>
                </IconButton>
              </Grid>
              {!isGPID && (
                <Grid item>
                  <IconButton
                    size="small"
                    onClick={() => push('/notificações')}
                  >
                    <Avatar className={classes.notificationAvatar}>
                      <BellIcon />
                    </Avatar>
                  </IconButton>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <>
          <Grid container item xs={5}>
            {!hideBackButton && (
              <Button
                component={Link}
                to={!!backLink ? backLink : '/'}
                startIcon={<ArrowLeftIcon />}
                className={classes.backButton}
              >
                Voltar
              </Button>
            )}
          </Grid>
          <Grid container item xs={7} justify="flex-end">
            <NotificationsButton />
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default Header;
